import { string, object, number, array, bool, mixed } from "yup";

export const EmptySubmitter = {
    key: 0,
    name: "",
    email: "",
    phone: ""
};

export const EmptyForm = {
    candidate: {
        name: "",
        url: "",
        member: ""
    },
    submitter: EmptySubmitter,
    invoice: {
        name: "",
        address: {
            street: "",
            postalCode: "",
            city: ""
        },
        nip: ""
    },
    agreements: {
        notifyAboutCompetition: false,
        notifyAboutOtherActivities: false,
        termsAndConditions: false
    },
    logo: {
        vector: null, // cdr, eps, ai, psd | jpg, png
    },
    submissions: []
};

export const EmptySubmission = {
    key: -1,
    category: "",
    title: "",
    description: "",
    presentation: null, // pdf
    clientStatement: null // pdf
};

export const Categories = [
    [
        "Regular Categories",
        "the most effective mobile campaign",
        "the most effective lead generation campaign",
        "the most effective social media campaign",
        "the most effective SEM campaign",
        "the most effective affiliate program",
        "the most effective video campaign",
        "the most effective use of data",
        "the most effective sales campaign",
        "the most effective use of influencer marketing in performance",
        "open category",
        "performance creativity in crisis",
        "the integrated campaign of the year",
    ],
    ["Main Categories", "Performance or/and Affiliate agency of the year", "Performance technology of the year"]
];

export const FormSchema = object().shape({
    candidate: object()
        .shape({
            name: string().required(),
            url: string().required(),
            member: string()
                .required()
                .oneOf(["tak", "nie"])
        })
        .required(),
    submitter: object()
        .shape({
            name: string().required(),
            email: string()
                .required()
                .email(),
            phone: string().required(),
        })
        .required(),
    invoice: object()
        .shape({
            name: string().required(),
            address: object().shape({
                street: string().required(),
                postalCode: string()
                    .required()
                    .matches(/^\d{2}-\d{3}$/),
                city: string().required()
            }),
            nip: string()
                .required()
                .matches(/^\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})$/)
        })
        .required(),
    agreements: object()
        .shape({
            notifyAboutCompetition: bool()
                .required()
                .oneOf([true]),
            notifyAboutOtherActivities: bool(),
            termsAndConditions: bool()
                .required()
                .oneOf([true])
        })
        .required(),
    logo: object()
        .shape({
            vector: mixed().required(), // todo:
        })
        .required(),
    submissions: array()
        .of(
            object().shape({
                key: number().required(),
                category: string()
                    .required()
                    .oneOf(Categories.reduce((a, i) => [...a, ...i], [])),
                title: string().required(),
                description: string()
                    .required()
                    .min(10)
                    .max(1000),
                presentation: mixed().required(), // todo:
                clientStatement: mixed().required() // todo:
            })
        )
        .required()
        .min(1)
        .max(3)
});
